import DescriptiveGalleryLoader from './versions/0.0.1/DescriptiveGalleryLoader';

export default DescriptiveGalleryLoader;
